const TOTAL_NOTIFICACOES = 'TOTAL_NOTIFICACOES'
const ARQUIVO_ESTRUTURADO = 'ARQUIVO_ESTRUTURADO'

export default {
  namespaced: true,
  state: {
    totalNotificacoes: 0,
    arquivoEstruturado: null
  },

  getters: {
    getTotalNotificacoes: (state) => state.totalNotificacoes,
    getArquivoEstruturado: (state) => state.arquivoEstruturado
  },

  mutations: {
    [TOTAL_NOTIFICACOES] (state, total) {
      state.totalNotificacoes = total
    },
    [ARQUIVO_ESTRUTURADO] (state, arquivo) {
      state.arquivoEstruturado = arquivo
    }
  },

  actions: {
    setTotalNotificacoes ({ commit }, total) {
      commit(TOTAL_NOTIFICACOES, total)
    },
    setArquivoEstruturado ({ commit }, arquivo) {
      commit(ARQUIVO_ESTRUTURADO, arquivo)
    }
  }
}